import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Checkbox from "@material-ui/core/Checkbox";
// core components
import styles from "assets/jss/material-dashboard-react/components/tableStyle.js";
import { infoColor } from "assets/jss/material-dashboard-react.js";
const useStyles = makeStyles(styles);

const ColoredCheckbox = withStyles({
  root: {
    "&$checked": {
      color: infoColor[0],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

export default function CustomTable({
  tableHead,
  tableData,
  tableHeaderColor,
  checkboxSelection,
  handleSelectAllClick,
  handleClick,
  selected,
  lastRowBold
}) {
  const classes = useStyles();

  const rowCount = tableData?.length;
  const numSelected = selected ? selected?.length : 0;
  const isItemSelected = (id) =>
    selected ? selected.indexOf(id) !== -1 : false;

  const onAllCheckboxClick = (event) => {
    if (handleSelectAllClick) handleSelectAllClick(event);
  };
  const onCheckboxClick = (event, id) => {
    if (handleClick) handleClick(event, id);
  };
  return (
    <div className={classes.tableResponsive}>
      <Table className={classes.table}>
        {tableHead !== undefined ? (
          <TableHead className={classes[tableHeaderColor + "TableHeader"]}>
            <TableRow className={classes.tableHeadRow}>
              {checkboxSelection && (
                <TableCell
                  padding="checkbox"
                  className={classes.tableHeadCells}
                >
                  <ColoredCheckbox
                    indeterminate={numSelected > 0 && numSelected < rowCount}
                    checked={rowCount > 0 && numSelected === rowCount}
                    onChange={onAllCheckboxClick}
                    inputProps={{
                      "aria-label": "select all rows",
                    }}
                  />
                </TableCell>
              )}
              {tableHead.map((prop, key) => {
                return (
                  <TableCell
                    className={classes.tableCell + " " + classes.tableHeadCell}
                    key={key}
                  >
                    {prop}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>
          {tableData?.map((prop, key) => {
            const isLastRow = key === tableData.length - 1;
            return (
              <TableRow key={key} className={`${classes.tableBodyRow}`}>
                {checkboxSelection && (
                  <TableCell
                    padding="checkbox"
                    className={classes.tableHeadCells}
                
                  >
                    <ColoredCheckbox
                      checked={isItemSelected(prop[0])}
                      onClick={(event) => onCheckboxClick(event, prop[0])}
                      inputProps={{ "aria-labelledby": prop[0] }}
                    />
                  </TableCell>
                )}
                {prop?.map((prop, key) => {
                  if (key > 0) {
               
                    return (
                      prop !== "" && 
                      <TableCell className={classes.tableCell} key={key} style={{fontWeight: isLastRow&& lastRowBold ? "bold" : "normal", }} >
                        {prop === "NA" ? "" : prop}
                      </TableCell>
                    );
                  }
                  return null;
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}

CustomTable.defaultProps = {
  tableHeaderColor: "gray",
  checkboxSelection: false,
  selected: [],
  handleSelectAllClick: null,
  handleClick: null,
};

CustomTable.propTypes = {
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray",
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  checkboxSelection: PropTypes.bool,
  selected: PropTypes.array,
  handleSelectAllClick: PropTypes.func,
  handleClick: PropTypes.func,
};